var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticStyle:{"border-radius":"6px"},attrs:{"fit":"cover","src":_vm.src,"preview-src-list":_vm.list}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }